import gql from "graphql-tag";

export const GetVideoById = gql`
  query GetVideoById($video: QueryableVideo!) {
    videos(video: $video) {
      id
      name
      wowzaId
      thumbnailUrl
      scheduleStatus
      scheduleStartTime
    }
  }
`;

export const GetVideos = gql`
  query GetVideos(
    $id: String
    $name: QueryableString
    $product: String
    $createdAt: QueryableDateTime
    $owner: String
    $cursor: String
    $limit: Int
  ) {
    videos(
      video: {
        id: $id
        name: $name
        createdAt: $createdAt
        owner: $owner
        product: $product
        cursor: $cursor
        limit: $limit
      }
    ) {
      id
      url
      name
      thumbnailUrl
      createdAt

      product {
        id
        name
        price
      }

      stats {
        totalOrders
        totalSales
        totalViews
      }
    }
  }
`;
